/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 排序方式。支持 `0/time`（按时间）、`1/like`（按点赞）、`2/reply`（按回复数）、`3/hot/hottest/最热`（按最热）。默认为 `0/time`。
 */
export const GetSocialBilibiliRepliesSort = {
  TimeCode: "0",
  Time: "time",
  LikeCode: "1",
  Like: "like",
  ReplyCode: "2",
  Reply: "reply",
  HotCode: "3",
  Hot: "hot",
  Hottest: "hottest",
  HotZh: "最热",
} as const;
/**
 * 排序方式。支持 `0/time`（按时间）、`1/like`（按点赞）、`2/reply`（按回复数）、`3/hot/hottest/最热`（按最热）。默认为 `0/time`。
 */
export type GetSocialBilibiliRepliesSort = ClosedEnum<
  typeof GetSocialBilibiliRepliesSort
>;

export const GetSocialBilibiliRepliesSort$zodSchema = z.enum([
  "0",
  "time",
  "1",
  "like",
  "2",
  "reply",
  "3",
  "hot",
  "hottest",
  "最热",
]).describe(
  "排序方式。支持 `0/time`（按时间）、`1/like`（按点赞）、`2/reply`（按回复数）、`3/hot/hottest/最热`（按最热）。默认为 `0/time`。",
);

export type GetSocialBilibiliRepliesRequest = {
  oid: string;
  sort?: GetSocialBilibiliRepliesSort | undefined;
  ps?: string | undefined;
  pn?: string | undefined;
};

export const GetSocialBilibiliRepliesRequest$zodSchema: z.ZodType<
  GetSocialBilibiliRepliesRequest
> = z.object({
  oid: z.string().describe("目标评论区的ID。对于视频，这通常就是它的 `aid`。"),
  pn: z.string().describe("要获取的页码，从1开始。默认为 `1`。").optional(),
  ps: z.string().describe("每页获取的评论数量，范围是1到20。默认为 `20`。")
    .optional(),
  sort: GetSocialBilibiliRepliesSort$zodSchema.optional(),
});

/**
 * 分页信息概览。
 */
export type GetSocialBilibiliRepliesPage = {
  num?: number | undefined;
  size?: number | undefined;
  count?: number | undefined;
  acount?: number | undefined;
};

export const GetSocialBilibiliRepliesPage$zodSchema: z.ZodType<
  GetSocialBilibiliRepliesPage
> = z.object({
  acount: z.number().optional(),
  count: z.number().optional(),
  num: z.number().optional(),
  size: z.number().optional(),
}).describe("分页信息概览。");

export type Hot = {};

export const Hot$zodSchema: z.ZodType<Hot> = z.object({});

export type LevelInfo = { current_level?: number | undefined };

export const LevelInfo$zodSchema: z.ZodType<LevelInfo> = z.object({
  current_level: z.number().optional(),
});

/**
 * 发表评论的用户信息。
 */
export type Member = {
  uname?: string | undefined;
  sex?: string | undefined;
  avatar?: string | undefined;
  level_info?: LevelInfo | undefined;
};

export const Member$zodSchema: z.ZodType<Member> = z.object({
  avatar: z.string().optional(),
  level_info: z.lazy(() => LevelInfo$zodSchema).optional(),
  sex: z.string().optional(),
  uname: z.string().optional(),
}).describe("发表评论的用户信息。");

/**
 * 评论内容。
 */
export type Content = { message?: string | undefined };

export const Content$zodSchema: z.ZodType<Content> = z.object({
  message: z.string().optional(),
}).describe("评论内容。");

export type Reply1 = {};

export const Reply1$zodSchema: z.ZodType<Reply1> = z.object({});

export type Reply2 = {
  rpid?: number | undefined;
  oid?: number | undefined;
  mid?: number | undefined;
  root?: number | undefined;
  parent?: number | undefined;
  count?: number | undefined;
  ctime?: number | undefined;
  like?: number | undefined;
  member?: Member | undefined;
  content?: Content | undefined;
  replies?: Array<Reply1> | undefined;
};

export const Reply2$zodSchema: z.ZodType<Reply2> = z.object({
  content: z.lazy(() => Content$zodSchema).optional(),
  count: z.number().optional(),
  ctime: z.number().optional(),
  like: z.number().optional(),
  member: z.lazy(() => Member$zodSchema).optional(),
  mid: z.number().optional(),
  oid: z.number().optional(),
  parent: z.number().optional(),
  replies: z.array(z.lazy(() => Reply1$zodSchema)).optional(),
  root: z.number().optional(),
  rpid: z.number().optional(),
});

/**
 * 成功！返回指定分页和排序的评论列表。
 */
export type GetSocialBilibiliRepliesResponse = {
  page?: GetSocialBilibiliRepliesPage | undefined;
  hots?: Array<Hot> | null | undefined;
  replies?: Array<Reply2> | undefined;
};

export const GetSocialBilibiliRepliesResponse$zodSchema: z.ZodType<
  GetSocialBilibiliRepliesResponse
> = z.object({
  hots: z.array(z.lazy(() => Hot$zodSchema)).nullable().optional(),
  page: z.lazy(() => GetSocialBilibiliRepliesPage$zodSchema).optional(),
  replies: z.array(z.lazy(() => Reply2$zodSchema)).optional(),
}).describe("成功！返回指定分页和排序的评论列表。");
